import React, { useReducer, useEffect, useState } from "react"
import Layout from "../components/layout/layout"
import Contact from "../components/contactus/ContactUs"
import SEO from "../components/seo"
import { getCountryCallingCode } from "react-phone-number-input"
import { requestService } from "../services"
import { formatNumber, validateEmail } from "../utils"
import SucessModal from "../components/modals/successModal/successModal"

const ContactUs = ({ location: { pathname } }) => {
  const [details, setDetails] = useReducer(
    (state, newState) => ({
      ...state,
      ...newState,
    }),
    {
      phone: "",
      name: "",
      email: "",
      company: "",
      comments: "",
      designation: "",
      country_code: "+1",
      terms: false,
      requesting: false,
      response: "",
      submitted: false,
    }
  )
  const [showSuccessModal, setShowSuccessModal] = useState(false)
  useEffect(() => {
    let timeout
    if (details.response) {
      setShowSuccessModal(true)
      timeout = setTimeout(() => {
        setShowSuccessModal(false)
        setDetails({ response: "" })
      }, 5000)
    }
    return () => {
      clearTimeout(timeout)
    }
  }, [details.response])
  const handleNumberSelect = value => {
    setDetails({ phone: value })
  }
  const getCountryCode = value => {
    let countryCode = value && getCountryCallingCode(value)
    setDetails({ country_code: `+${countryCode}` })
  }
  const onChange = e => {
    const { name, value } = e.target
    setDetails({ [name]: value })
  }
  const onCheck = e => {
    setDetails({ terms: e.target.checked })
  }
  const submit = async () => {
    setDetails({ submitted: true })
    const {
      name,
      phone,
      email,
      company,
      comments,
      designation,
      country_code,
      terms,
    } = details
    let data
    if (
      name !== "" &&
      phone !== "" &&
      email !== "" &&
      company !== "" &&
      comments !== "" &&
      designation !== "" &&
      validateEmail(email)
    ) {
      if (!terms) {
        alert("please accept our terms and conditions")
        return
      }
      let number = formatNumber(phone)
      data = {
        form_name: "contact form",
        page_url: pathname,
        section_name: "contact_section",
        name,
        company_name: company,
        designation,
        email,
        country_code,
        phone_number: number,
        comments,
      }
      try {
        setDetails({ requesting: true })
        let result = await requestService.contactRequest(data)
        window.rudderanalytics.track(data.form_name, data)
        setDetails({
          phone: "",
          name: "",
          email: "",
          company: "",
          comments: "",
          designation: "",
          country_code: "",
          requesting: false,
          terms: false,
          response: result && result.more_info,
          submitted: false,
        })
      } catch (err) {
        console.log(err)
        setDetails({ requesting: false })
      }
    }
  }
  return (
    <Layout withBrand slidePosition={0}>
      {showSuccessModal && <SucessModal show={showSuccessModal} />}
      <SEO
        description="Connect with us today to know more about the brand analytics technologies we use and what we can do to reach your eCommerce business to the next leve"
        keywords="wersel, wersel brand analytics, wersel contact us, wersel data hub"
        title="Contact Us - Wersel Workdesk"
        url="www.wersel.io/contact"
      />
      <Contact
        handleNumberSelect={handleNumberSelect}
        getCountryCode={getCountryCode}
        details={details}
        onChange={onChange}
        submit={submit}
        onCheck={onCheck}
      />
    </Layout>
  )
}

export default ContactUs
